module.exports = "img/publish.340a7dd748c38c4e93fcc0b7885cfde6.png";